<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Onsite Renewable" :path="breadcrumbPath" />
    <div class="px-2">
      <FilterS11
        customer-list-source="onSiteRenewable"
        @filterHandle="filterHandle"
      />
    </div>
    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-input
                      size="large"
                      v-model="search"
                        :placeholder="selectedSearchBy != '' ? 'Search by ' + (convertLabel(selectedSearchBy)) : 'Choose a search by options' "
                        :prefix-icon="Search"
                        class="mixedSearchBar"
                        id="mixedSearchBar-input"
                        clearable
                        @clear="handleReload"
                    >
                      <template #prepend>

                        <!-- search_by select -->
                        <el-tooltip
                          effect="light"
                          placement="top"
                          show-after="500"
                          hide-after="300"
                          >
                          <template #content > 
                              <span :style="{fontSize: '12px', textAlign: 'left'}"> {{ "Select Search by" }} </span>
                          </template>

                          <el-select
                            v-model="selectedSearchBy"
                            placeholder="Select"
                            style="min-width: 117px; height: 40px;"
                            @change="handleSelectSearchBy"
                            class="mixedSearchBar-select"
                          >
                            <template #label>
                              <span>Search by: </span>
                              <span style="font-weight: bold">{{ convertLabel(searchBytabs) }}</span>
                            </template>
                            <el-option
                              v-for="(item, index) in search_by_dropdown['selectedTableTab']"
                              :key="index"
                              :label="convertLabel(item)"
                              :value="item"
                            />
                          </el-select>
                        </el-tooltip>
                      </template>
                      
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <!-- export button -->
              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                  <el-button
                      v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                      @click.stop="handleNew"
                      class="newAddButtonNoText new-button-behavior x-end"
                      size="small"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newAddButtonNoText"></use>
                        </svg>
                    </el-button>
                    <el-tooltip
                      effect="light"
                      placement="top"
                      :disabled="canExport"
                      show-after="300"
                      hide-after="200"
                    >
                      <template #content>
                        <span :style="{fontSize: '12px', textAlign: 'left'}">
                          Apply Customer and Monitoring Period filters to enable download
                        </span>
                      </template>
                      <el-button
                        @click.stop="handleExportFile"
                        class="new-download-file-btn new-button-behavior x-end"
                        :disabled="!canExport"
                      >
                          <svg class="width-40 height-40">
                            <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                          </svg>
                      </el-button>
                    </el-tooltip>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :usersDataProp="filter_renewable"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      @close_modal="close_modal"
      @confirm_modal="confirm_modal"
    />
  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import { exportToExcel } from "../dashboard/common/exportExcel";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
import ShowDetail from "./dialogDetail.vue";
import FilterS11 from "../dashboard/common/filter-s11.vue";
import { ElMessageBox } from "element-plus";
import { convertToTitleCase } from "../dashboard/common/common-tools";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "site-renewables",
  components: {
    Breadcrumbs,
    FilterS11,
    ShowDetail,
    DataTable,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Input",
          disabled: true,
          href: "",
        },
        {
          title: "Onsite Renewable",
          disabled: false,
          href: "/on-site-renewable",
          active: true,
        },
      ],

      show: true,
      renewableDataList: [],

      search_by_dropdown: 
        {
          selectedTableTab: [
            'site_name',
            'battery_to_ev',
            'solar_to_ev',
            'grid_to_ev',
            'solar_to_grid',
            'time',
          ],
        },

      selectedSearchBy: 'site_name',
      search: "",

      filter: {
        customer_id: null,
        startDate: null,
        endDate: null,
      },

      current_page: 1,
      page_size: 20,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
    };
  },
  watch: {},
  computed: {
    filter_renewable() {
      return this.renewableDataList;
    },
    apiFilters() {
      return {
        customer_id: this.filter.customer_id || null,
        start_time: this.filter.startDate || null,
        end_time: this.filter.endDate || null,
      };
    },
    canExport() {
      return !!(
        this.filter.customer_id &&
        this.filter.startDate &&
        this.filter.endDate
      );
    },
  },
  mounted() {
    this.fetchRenewableData(this.current_page);
  },
  methods: {
    convertLabel(str) {
      return convertToTitleCase(str);
    },

    handleSelectSearchBy(search_by){
      this.selectedSearchBy = search_by;
    },

    filterHandle(event) {
      this.filter = {
        customer_id: event.customer_id || null,
        startDate: event.startDate || null,
        endDate: event.endDate || null,
      };
      this.current_page = 1;
      this.fetchRenewableData(this.current_page);
    },

    fetchRenewableData(page) {
      this.loading = true;
      UserService.getOnSiteRenewable(
        this.selectedSearchBy,
        this.search,
        page,
        this.perPageCount,
        false,
        this.apiFilters
      )
        .then(
          (response) => {
            this.renewableDataList = response.data.on_site_renewables;
            this.total_items = response.data.total_record;
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    DeleteRenewable(user, index) {
      UserService.deleteSiteRenewableParam(user.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            this.renewableDataList.splice(index, 1);
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    // eslint-disable-next-line no-unused-vars
    handleRowClick(row, column, event) {
      // console.log(row, column, event);
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    confirm_modal(event) {
      if (this.renewableDataList.length == this.current_row_index)
        this.renewableDataList.push(event);
      else this.renewableDataList[this.current_row_index] = event;
      this.show_modal = false;
    },

    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },

    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },

    async handleExportFile() {
      if (!this.canExport) {
        return;
      }
      await UserService.getOnSiteRenewable(
        this.selectedSearchBy,
        this.search,
        1,
        this.perPageCount,
        true,
        this.apiFilters
      ).then(
        async (response) => {
        let dataList = response.data.on_site_renewables;
        
        if (dataList.length > 0) {
          const skipKeys = ["id", "customer_id", "site_id"]; // Keys to skip
          const fileName = "OnSiteRenewableList.xlsx"; // File name
          const newWorksheetName = "OnSite Renewable List"; // Worksheet name
          const title = "OnSite Renewable List"; // Title for the Excel file

          try {
          await exportToExcel({
            dataList,
            skipKeys,
            fileName,
            newWorksheetName,
            title,
          });
        } catch (err) {
          console.log("error when export excel", err.message);
          
        }
          } else {
            console.log("empty data list");
          }
      })

    },

    // handleExportFile() {
    //   if (this.filter_renewable.length > 0) {
    //     const myHeader = [
    //       "charging_site_title",
    //       "time",
    //       "grid_to_ev",
    //       "solar_to_ev",
    //       "solar_to_grid",
    //       "battery_to_ev",
    //     ];
    //     const ws = XLSX.utils.json_to_sheet(this.filter_renewable, {
    //       header: myHeader,
    //     });
    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "Data");
    //     XLSX.writeFileXLSX(wb, "OnSiteRenewableList.xlsx");
    //   }
    // },

    reset_filter(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
        this.fetchRenewableData(this.current_page);
      } else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    handleReload() {
      this.current_page = 1;
      this.fetchRenewableData(this.current_page);
    },
    handleNew() {
      let data = {
        first_name: "",
        last_name: "",
        email: "",
        is_staff: false,
        is_superuser: false,
        is_active: true,
        renewable_id: null,
        id: 0,
      };
      this.current_row_index = this.renewableDataList.length;
      this.data_modal = JSON.stringify(data);
      this.show_modal = true;
    },
    filterSearch(event) {
      this.search = event.search;
    },

    deleteRow(event, index) {
      console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.DeleteRenewable(event, index);
          // ElMessage({
          //   type: "success",
          //   message: "Delete completed",
          // });
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
